import { Link } from '@mui/material';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface IMUIRouterLink {
	to: string;
	children: ReactNode;
	color?: 'inherit' | 'primary' | 'secondary';
}

/**
 * Custom MUI Link (extending styling) that extends React Router Link component
 * @param to path to route
 * @param children embedded components
 */
const MUIRouterLink = ({ to, children, ...rest }: IMUIRouterLink) => {
	return (
		<Link component={RouterLink} to={to} {...rest}>
			{children}
		</Link>
	);
};

export default MUIRouterLink;
